import React from 'react';
import { firstError } from '@/utils/errors';
import BackButton from '@/components/buttons/BackButton';
import ForwardButton from '@/components/buttons/ForwardButton';
import TabActions from '@/components/tabs/TabActions';
import Selectors from '../../hooks/selectors';
import DatasetWizardCancelButton from '../../containers/DatasetWizardCancelButton';

const AttachmentsActions = ({
  category,
  code,
  compact,
  goBack,
  goForward,
}) => {
  const { disableEdit, readErrors } = Selectors.useDatasetWizardActionsContainer({ category, code });
  return (
    <TabActions className="aridhia-dataset-wizard-actions">
      <DatasetWizardCancelButton category={category} code={code} />
      <BackButton onClick={goBack} iconOnly={compact} disabled={disableEdit} />
      <ForwardButton disabled={disableEdit || firstError(readErrors)} iconOnly={compact} onClick={goForward} />
    </TabActions>
  );
};

export default AttachmentsActions;
